import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { withRouter } from "react-router";

import LoggedInMenu from "./LoggedInMenu";
import OcrProcessDropzone from "./OcrProcessDropzone";
import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";
import KVALogoWide from "./KVALogoWide";

interface IContactPageProps {
  history: any;
  location: any;
  match: any;
}

class ContactPage extends React.Component<IContactPageProps> {
  state: {
    showModal: boolean;
  };

  constructor(props: IContactPageProps) {
    super(props);
    this.state = { showModal: false };
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div className="sitecontent">
                  <h3 className="sectiontitle">Kontakt</h3>
                  <div style={{ padding: 50 }}>
                    <KVALogoWide></KVALogoWide>
                    <p style={{ paddingTop: "1em" }}>
                      KVA+ Gesellschaft für private Krankenversicherung
                      Abrechnungshilfe mbH
                      <br />
                      Altenkesseler Str. 17
                      <br />
                      Gebäude/B1
                      <br />
                      66115 Saarbrücken
                      <br />
                      <a href="https://www.kva-plus.de">www.kva-plus.de</a>
                    </p>
                    <p style={{ paddingTop: "1em" }}>
                      Telefon: 0681 41096 766 (Mo.&ndash;Fr. 08:00&mdash;17:00
                      Uhr)
                      <br />
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default withRouter(ContactPage);
